/**
 * Zentrale EUR-Anzeige-Formatierer (BUGHUNT-2026-08-15 Q9).
 *
 * WARUM HIER: Vor diesem Modul existierten ~8 wortgleiche EUR-Formatierer verstreut ueber
 * `apps/api/src/lib/*` und `packages/pricing/src/zahlungsstaffel.ts`. Die eine Stelle muss in
 * DIESEM Paket liegen, weil `apps/api` von `@maestro/pricing` abhaengt und nicht umgekehrt —
 * die Staffel-Fehlermeldungen brauchen den Formatierer, koennen aber nichts aus `apps/api`
 * importieren.
 *
 * REINE ANZEIGE: Hier wird nichts gerechnet. Betraege/Summen entstehen ausschliesslich in der
 * Preis-Engine (`index.ts`) — Integer-Cents rein, formatierter Text raus.
 */

export type AnzeigeSprache = "de" | "en" | "it" | "fr";

/** Intl-Ortskennung je Anzeigesprache (nur Formatierung). */
export const ANZEIGE_ORT: Record<AnzeigeSprache, string> = { de: "de-DE", en: "en-IE", it: "it-IT", fr: "fr-FR" };

/** Gebietsschema zur Sprache; unbekannte Werte (auch geerbte wie "toString") fallen auf de-DE zurueck. */
export function ortFuer(lang: string): string {
  return Object.hasOwn(ANZEIGE_ORT, lang) ? ANZEIGE_ORT[lang as AnzeigeSprache] : "de-DE";
}

// Intl.NumberFormat einmal je Sprache bauen (Konstruktion ist teuer, format() billig).
const EUR_WAEHRUNG: Record<AnzeigeSprache, Intl.NumberFormat> = {
  de: new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }),
  en: new Intl.NumberFormat("en-IE", { style: "currency", currency: "EUR" }),
  it: new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }),
  fr: new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }),
};

/** Cent-Betrag als Waehrungstext: 123456 -> "1.234,56 €" (de), "€1,234.56" (en), "1.234,56 €" (it), "1 234,56 €" (fr, schmales Leerzeichen als Tausendertrenner). */
export function euro(cents: number, lang: AnzeigeSprache = "de"): string {
  return (Object.hasOwn(EUR_WAEHRUNG, lang) ? EUR_WAEHRUNG[lang] : EUR_WAEHRUNG.de).format(cents / 100);
}

const EUR_ZAHL = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/**
 * Cent-Betrag als blosse Zahl mit genau zwei Nachkommastellen, OHNE Waehrungssymbol:
 * 123456 -> "1.234,56". Fuer Texte, die "EUR" selbst dazuschreiben (Deckungshinweis,
 * Kostenuebernahme-Platzhalter).
 */
export function euroZahl(cents: number): string {
  return EUR_ZAHL.format(cents / 100);
}
